import request from '@/utils/request'
import  qs from 'qs'

// 获取日志列表
export function queryOperationLogList(data) {
  return request({
    url: '/data/log/queryOperationLogList',
    method: 'post',
    data:qs.stringify(data)
  })
}

// 查询日志详细信息
export function queryOperationDetail(data) {
  return request({
    url: '/data/log/queryOperationDetail',
    method: 'post',
    data:qs.stringify(data)
  })
}
